// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.jourAujourdhui[data-v-5932359e]{\n  background-color: #65a2bc;\n}\n.jourSuivant[data-v-5932359e]{\n  background-color: #7bb1c6;\n}\n.jourDemain[data-v-5932359e]{\n  background-color: #7bb1c6;\n}\n.jourPasses[data-v-5932359e]{\n  background-color: #d2a16f;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
